import React, { useState } from "react";
import * as THREE from "three";
import videoUrl from "../../assets/Video/anne.mp4";


export function VideoScreen(props) {
  const [video] = useState(() => {
    const vid = document.createElement("video");
    vid.src = videoUrl;
    vid.crossOrigin = "Anonymous";
    vid.loop = true;
    vid.muted = true;
    vid.play();
    return vid;
  });

  return <>
    <mesh rotation={[0, Math.PI / 2, 0]} position={[1.6, 0, 0]}>
      <planeGeometry args={[16 / 7, 9 / 7]} />
      <meshStandardMaterial emissive={"white"} side={THREE.DoubleSide}>
        <videoTexture attach="map" args={[video]} />
        <videoTexture attach="emissiveMap" args={[video]} />
      </meshStandardMaterial>
    </mesh>
  </>
}